import React from "react";
import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import {useTranslation} from "react-i18next";
import Collapsable from "../../common/Collapsable/Collapsable";

function InvestigateServiceSettings(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        style,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.InvestigateSettings')}
            style={style} isDisabled={isDisabled}
        >
            <div className="settings-table">
                <div className="table-row-group">
                    <SettingsRowValue label={t('thirdPartyService:label.url')}
                                      value={thirdPartyService.url} isDisabled={isDisabled}/>
                </div>

                <div className="table-row-group">
                    <SettingsRowValue label={t('thirdPartyService:label.serviceUrl')}
                                      value={thirdPartyService.serviceUrl} isDisabled={isDisabled}/>

                </div>
            </div>
        </Collapsable>
)
}

export default InvestigateServiceSettings;
